import React from 'react';
import SecureUpload from './SecureUpload';

export const Home = () => (
  <div>
    <SecureUpload />
  </div>
);

export default Home;
